<template>
  <v-list-item @click="mailActive = !mailActive" class="px-6">
    <v-list-item-icon>
      <v-icon>mail_outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ locales['notifications-email'] }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-switch v-model="mailActive" readonly color="primary"></v-switch>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      isActive: false,
    }
  },
  computed: {
    ...mapGetters('locales', ['locales', 'locale']),
    ...mapGetters('profile', ['emailNotification']),
    mailActive: {
      get: function() {
        return this.isActive;
        // return this.emailNotification === 1
      },
      set: function(val) {
        this.isActive = val
        this.saveMailNotifications({
          emailNotification : this.isActive ? '1' : '0'
        })
        .then((data) => {
          if (data.error) {
						this.$store.commit('snack/open', { color: "error", text: this.locales['err'] + '! ' + (this.locales['error-' + data.error.code] || '') });
            this.isActive = !val
					} else {
            this.isActive = (data.email === 1 || data.email === '1') ? true : false
          }
        })
      }
    },
  },
  watch: {
    emailNotification() {
      this.isActive = this.emailNotification === 1
    }
  },
  mounted() {
    this.isActive = this.emailNotification === 1
  },
  methods: {
    ...mapActions('profile', ['saveMailNotifications']),
  }
}
</script>